import { useSelector } from "react-redux";
import GuidedSearchText from "./GuidedSearchText";
import { normaliseVisualRefinements } from "../GuidedSearch/normaliseVisualRefinements";
import { getLocation } from "../../../../state/modules/router/selectors";
import {
  getGuidedSearchData,
  getSearchTerm,
} from "../../../../state/modules/search";

const normaliseComparableValue = (value) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

export const getResolvedSearchTerm = (searchTerm, location) => {
  const normalisedSearchTerm = normaliseComparableValue(searchTerm);

  if (normalisedSearchTerm) {
    return searchTerm;
  }

  if (typeof location?.query?.q === "string") {
    return location.query.q;
  }

  return new URLSearchParams(location?.search).get("q") || "";
};

export const getGuidedSearchCategories = ({ guidedSearchData, searchTerm }) =>
  normaliseVisualRefinements(guidedSearchData, searchTerm);

const GuidedSearchTextContainer = () => {
  const searchMetadata = useSelector(getGuidedSearchData);
  const searchTerm = useSelector(getSearchTerm);
  const location = useSelector(getLocation);
  const currentPath = location?.pathname;
  const currentSearch = location?.search;

  const guidedSearchCategories = getGuidedSearchCategories({
    guidedSearchData: searchMetadata,
    searchTerm: getResolvedSearchTerm(searchTerm, location),
  });

  if (guidedSearchCategories.length === 0) {
    return null;
  }

  return (
    <GuidedSearchText
      guidedSearchCategories={guidedSearchCategories}
      currentPath={currentPath}
      currentSearch={currentSearch}
    />
  );
};

export default GuidedSearchTextContainer;
